/**
 * Landing-page FAQ — SINGLE SOURCE OF TRUTH.
 *
 * Consumed by:
 *   1. src/pages/Landing.jsx — the visible FAQ section
 *   2. vite.config.js (seoJsonLd plugin) — FAQPage JSON-LD injected
 *      into index.html at build time
 *
 * Copy rules: answers are self-contained (restate the subject), never
 * name competing products or AI vendors, and only claim shipped
 * behavior (platforms: Instagram, Facebook, X — nothing else yet).
 */
export const FAQS = [
  {
    q: 'What is Markaii?',
    a: 'Markaii is an AI marketing operating system for SaaS founders. It plans each brand\'s marketing, drafts platform-native content on schedule, routes everything through a human approval queue, publishes automatically to Instagram, Facebook, X, LinkedIn, and TikTok, and revises the plan from real engagement data.',
  },
  {
    q: 'Does the AI post without my approval?',
    a: 'No. Every draft waits in the approval queue until you approve it. Auto-publish exists but is opt-in per project — by default, nothing goes out without a human decision.',
  },
  {
    q: 'Which platforms does Markaii publish to?',
    a: 'Markaii publishes to Instagram, Facebook, X, LinkedIn Company Pages, and TikTok through their official APIs today. Each post shows its per-platform status, including the reason when a platform is intentionally skipped.',
  },
  {
    q: 'How much time does it actually take?',
    a: 'Most founders spend about 15 minutes a week in Markaii: skim the drafts, approve or reject, done. Planning, writing, image rendering, publishing, and analytics run on their own.',
  },
  {
    q: 'Can I edit what the AI writes?',
    a: 'Yes. You can edit any draft, regenerate it with feedback, or upload your own content into the same approval-and-publish pipeline.',
  },
  {
    q: 'How does the learning loop work?',
    a: 'Markaii ingests engagement for every published post, scores what worked, and updates the brand\'s plan — adjusting pillar mix, hooks, and cadence — so the content strategy improves from evidence, not guesses.',
  },
  {
    q: 'How many brands can I manage?',
    a: 'The Solo plan includes 1 brand, Pro includes 3, and Agency includes 10 — each brand with its own plan, pillars, voice, and social connections. Above 10 brands, contact sales@markaii.com.',
  },
  {
    q: 'What does Markaii cost?',
    a: 'Solo is $79/month, Pro is $249/month, and Agency is $599/month. Annual billing saves two months on every plan, and every plan starts with a 14-day free trial.',
  },
];
